import React from 'react';
import styled, { useTheme } from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { CloudActions } from '@portal/portal-core';

import * as FjPrimitives from 'components/primitives';
import { routeIsAdmin } from 'utils';
import { Select } from 'components/styled-primitives';
import {
  currentTabSelector,
  userAdminSelector,
  selectCostCenterForAdminProductTab,
  selectCostCenterDropdownOptions,
  selectAdminCostCenterState,
} from '../../../selectors';

interface CostCenter {
  id: string;
  name: string;
}

const CCSelect = styled(Select).attrs(({ theme }) => ({
  bgColor: theme.colors.black,
  bgColorIcon: theme.colors.black,
  selectedValueColor: theme.colors.white,
  noBorder: true,
  width: FjPrimitives.fjSelectWidths.WIDE,
  alignRight: true,
}))`
  font-size: ${({ theme }) => theme.fontSizes.h5};
  /* TODO/HACK: A bit dirty to reach into internal structure of FjSelect */
  span {
    margin-top: 5px;
  }
`;

const CostCenterSelector = (): React.ReactElement | null => {
  const userAdminState = useSelector(userAdminSelector);
  const selectedCostCenterInfo = useSelector(selectCostCenterForAdminProductTab);
  const costCenterDropdownOptions = useSelector(selectCostCenterDropdownOptions);
  const productName = useSelector(currentTabSelector);
  const adminCostCenterState = useSelector(selectAdminCostCenterState);
  const dispatch = useDispatch();
  // useTheme keeps parity with the previous withTheme HOC for the styled CCSelect context.
  useTheme();

  const setCostCenter = (costCenterName?: string, costCenters?: unknown): void => {
    if (costCenterName && costCenters) {
      const costCenterInfo = Object.values(
        costCenters as Record<string, CostCenter>,
      ).find((costCenter) => costCenter.name === costCenterName);
      dispatch(CloudActions.userAdminForceUpdate(costCenterInfo!.id, productName));
    }
  };

  if (!userAdminState || !selectedCostCenterInfo || !routeIsAdmin()) {
    return null;
  }

  const { id, name } = selectedCostCenterInfo as CostCenter;

  if (costCenterDropdownOptions) {
    return (
      <CCSelect
        key={id}
        defaultValue={name}
        onChange={(value?: string) => setCostCenter(value, adminCostCenterState)}
        options={costCenterDropdownOptions}
      />
    );
  }
  return null;
};

export default CostCenterSelector;
